import { css, CSSResult } from 'lit'


export const style: CSSResult = css`
  :host {
    display: block;
  }

  .csc-store-stock-list {
    display: block;
  }
`
